import { render, staticRenderFns } from "./Consumables.vue?vue&type=template&id=76cc6db2&scoped=true&"
import script from "./Consumables.vue?vue&type=script&lang=js&"
export * from "./Consumables.vue?vue&type=script&lang=js&"
import style0 from "./Consumables.vue?vue&type=style&index=0&id=76cc6db2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cc6db2",
  null
  
)

export default component.exports